export default {
  paged: {
    select: 'id,status,processInstanceName,actionInstanceId,created',
    searchSelect: [],
    notSelectSearch:
      'delegatedUser,process,environment,actionInstance,processInstance,status,actionInstanceId,processInstanceName,created',
    expand: {
      delegatedUser: { select: 'fullName' },
      processInstance: { select: 'name' },
      actionInstance: { select: 'status' },
      process: { select: 'name' },
      environment: { select: 'name' },
    },
  },
};
